import httpClient from '@/shared/http-eserv-client';
import { formatDate } from '@/utils/report-utils';

const getUserCredits = (userId) => httpClient.get(`/UserCredits?userId=${userId}`);

const applicationTypes = () => httpClient.get('/Products');

const fetchSageReports = (dateType, date, applicationType) => {
  const dateParam = `${dateType}=${date ? formatDate(date) : ''}`;
  const applicationTypeParam = `applicationType=${applicationType.replace('&', '%26')}`;

  return httpClient.get(`/Reports/GLSummary?${dateParam}&${applicationTypeParam}`);
};

// const composeInvoiceStatusFilters = (invoiceStatuses) => {
//   if (!invoiceStatuses) return '';

//   const fStrings = [];
//   const numberOfStatuses = invoiceStatuses.length;
//   if (numberOfStatuses > 1) fStrings.push('(');

//   for (let i = 0; i < numberOfStatuses; i += 1) {
//     fStrings.push(`invoiceStatus eq '${invoiceStatuses[i]}'`);
//     if ((i + 1) < numberOfStatuses) fStrings.push(` or `);
//   }
//   if (numberOfStatuses > 1) fStrings.push(')');
//   return fStrings.join('');
// };

const fetchInvoices = (dateType, dateFrom, dateTo, applicationType, invoiceType) => {
  const url = '/ApplicationRequests/AllRptInvoices';
  const appTypeParam = `applicationType=${applicationType.replace('&', '%26')}`;
  const invTypeParam = `invoiceType=${invoiceType}`;
  const dateTypeParam = `dateType=${dateType}`;
  const startDateParam = `startDate=${formatDate(dateFrom)}`;
  const endDateParam = `endDate=${formatDate(dateTo)}`;

  return httpClient.get(`${url}?${appTypeParam}&${invTypeParam}&${dateTypeParam}&${startDateParam}&${endDateParam}`);
};

const fetchHistoricalInvoices = (dateType, dateFrom, dateTo, applicationType) => {
  const url = '/ApplicationRequests/AllRptHistoricalInvoices';
  const appTypeParam = `applicationType=${applicationType.replace('&', '%26')}`;
  const dateTypeParam = `dateType=${dateType}`;
  const startDateParam = `startDate=${formatDate(dateFrom)}`;
  const endDateParam = `endDate=${formatDate(dateTo)}`;

  return httpClient.get(`${url}?${appTypeParam}&${dateTypeParam}&${startDateParam}&${endDateParam}`);
};

// eslint-disable-next-line import/prefer-default-export
export {
  getUserCredits,
  applicationTypes,
  fetchSageReports,
  fetchInvoices,
  fetchHistoricalInvoices,
};
